module.exports = __webpack_public_path__ + "media/images/countrysquared/kw-74b204177b2e0011b4b7e9a72e8118da.svg";